import BaseComponent from '../abstracts/BaseComponent';

export default class TogglePasswordComponent extends BaseComponent {
  get SELECTORS() {
    return {
      trigger: '.js-toggle-password',
      input: 'input'
    };
  }

  get CLASSES() {
    return {
      visible: 'visible'
    };
  }

  constructor(props) {
    super(props);
    this.togglePassword();
  }

  togglePassword() {
    const triggers = this.$el.querySelectorAll(this.SELECTORS.trigger);
    const inputs = this.$el.querySelectorAll(this.SELECTORS.input);
    triggers.forEach((trigger) => {
      this.$on('click.password', (e) => {
        e.preventDefault();
        e.currentTarget.classList.toggle(this.CLASSES.visible);
        inputs.forEach((el) => {
          if (el.type === 'password') {
            el.type = 'text';
          } else {
            el.type = 'password';
          }
        });
      }, trigger);
    });
  }
}
